import React from "react";
import { ZoomClient } from "../index-types";
export default React.createContext<ZoomClient | null>(null);
